module.exports = __webpack_public_path__ + "img/titan_logo.f414d6e7.png";